import { call, take } from 'redux-saga/effects';
import axios          from 'axios';

const apiEndpoint = 'https://www.yisumatica.org.il/yisumaticaApi/recordError.php';

function* reportEvent(): Generator<any,any,any> {
  while(true) {
    try {

        const input = yield take('RECORD_ERROR_SAGA');

        const { data, endpoint } = input.payload;

        if (process.env.NODE_ENV === 'development') {
            console.log('input.payload  :   ',input.payload)
        }
        if (process.env.NODE_ENV === 'production') {

             const obj = { data: JSON.stringify(data), endpoint: endpoint }

             const res = yield call( axios.post, apiEndpoint, obj);
             console.log('res : ',res)
        }

    }
    catch(err) {
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default reportEvent;
